import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "points" }

import {ref} from "vue";

import {Contact, HeartHandshake, Home, Info, Menu, X} from "lucide-vue-next";


import '@/assets/styles/sidebar.css';

/**
 * ref-variable
 *
 * ÜBERSCHRIFT BLAU
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarComponent',
  setup(__props) {
/**
 * creating an adaptive sidebar
 */
const isOpen = ref(false);

/**
 * Toggler for switching close and open
 */
const toggleSidebar = () => {
  isOpen.value = !isOpen.value;
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (!isOpen.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "menu",
            onClick: toggleSidebar
          }, [
            _createVNode(_unref(Menu))
          ]))
        : _createCommentVNode("", true),
      (isOpen.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "overlay",
            onClick: toggleSidebar
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["sidebar", {open: isOpen.value}])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          class: "close-btn",
          onClick: toggleSidebar
        }, [
          _createVNode(_unref(X))
        ]),
        _cache[0] || (_cache[0] = _createElementVNode("h1", null, "Gallus Pflegedienst e.K.", -1))
      ]),
      _createElementVNode("nav", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: "/",
          onClick: toggleSidebar,
          class: "points-link"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Home)),
            _cache[1] || (_cache[1] = _createTextVNode(" Home ", -1))
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/about",
          onClick: toggleSidebar,
          class: "points-link"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Info)),
            _cache[2] || (_cache[2] = _createTextVNode(" Über Uns ", -1))
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/services",
          onClick: toggleSidebar,
          class: "points-link"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(HeartHandshake)),
            _cache[3] || (_cache[3] = _createTextVNode(" Dienstleistungen ", -1))
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/contact",
          onClick: toggleSidebar,
          class: "points-link"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Contact)),
            _cache[4] || (_cache[4] = _createTextVNode(" Kontakt ", -1))
          ]),
          _: 1
        })
      ])
    ], 2)
  ], 64))
}
}

})